var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 55,
    viewBox: "0 0 40 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 354",
    d: "M37 3H3V37L20 51L37 37V3Z",
    fill: "#230047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 354 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V38.4158L20 54.8864L0 38.4158V0ZM37 3V37L20 51L3 37V3H37Z",
    fill: "#410096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 378",
    d: "M20 51L29 43.5L20 35.5L11 43.5L20 51Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 377",
    d: "M37 11V8L20 15L3 8V11L20 18.5L37 11Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 398",
    d: "M37 3H3V5L20 11.5L37 5V3Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M20 22L21.4593 26.4914H26.1819L22.3613 29.2672L23.8206 33.7586L20 30.9828L16.1794 33.7586L17.6387 29.2672L13.8181 26.4914H18.5407L20 22Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 379",
    d: "M3 37V18.5L7 21.5V40L3 37Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 380",
    d: "M37 37V18.5L33 21.5V40L37 37Z",
    fill: "#F0B90B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/SS.f8bf6817.svg";
export { ForwardRef as ReactComponent };